import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/autocomplete/autocomplete.styles.ts
var autocomplete_styles_default = r` ${component_styles_default} .autocomplete__panel { overscroll-behavior: none; pointer-events: none; max-height: none; overflow: unset; } .autocomplete__panel--open { background-color: var(--sl-color-neutral-0); border-radius: var(--sl-border-radius-large); border: 1px solid var(--sl-color-gray-200); box-shadow: 0px 7px 8px 0px hsla(0, 0%, 0%, 0.1); pointer-events: all; } .autocomplete__positioner { z-index: var(--sl-z-index-dropdown); } :host([disabled]) { pointer-events: none; } `;

export {
  autocomplete_styles_default
};
